import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import CloseBtn from "../modals/CloseBtn";

export default function FilterModal({
  show,
  onHide,
  initialFilters = {},
  onApply,
  onFiltersChange = () => {},
}) {
  const [filters, setFilters] = useState({});
  // const [filters, setFilters] = useState({
  //   is_client_details_received: "",
  //   payment_status: "",
  //   payment_confirmed: "",
  //   is_approved_by_partner: "",
  //   print_status: "",
  //   is_sleeve_handover_to_warehouse: "",
  //   is_sleeve_received_to_warehouse: "",
  //   start_date: "",
  //   end_date: "",
  //   ...initialFilters,
  // });

  const [dateError, setDateError] = useState({ start: "", end: "" });

  const normalizeValue = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return val;
  };

  const updateFilter = (key, value) =>
    setFilters((prev) => ({ ...prev, [key]: normalizeValue(value) }));

  const clearFilters = () => {
    setFilters({
      is_client_details_received: "",
      payment_status: "",
      payment_confirmed: "",
      is_approved_by_partner: "",
      print_status: "",
      is_sleeve_handover_to_warehouse: "",
      is_sleeve_received_to_warehouse: "",
      start_date: "",
      end_date: "",
    });
    setDateError("");
  };

  useEffect(() => {
    const s = filters.start_date;
    const e = filters.end_date;

    if (!s && e) {
      setDateError({ start: "* Please select Start Date", end: "" });
      return;
    }

    if (s && !e) {
      setDateError({ start: "", end: "* Please select End Date" });
      return;
    }

    if (s && e) {
      const start = new Date(s);
      const end = new Date(e);
      if (end < start) {
        setDateError({ start: "", end: "* End date must be after Start date" });
        return;
      }
    }

    setDateError({ start: "", end: "" });
  }, [filters.start_date, filters.end_date]);

  useEffect(() => {
    if (!dateError) {
      onFiltersChange(filters);
    }
  }, [filters, dateError]);

  useEffect(() => {
    if (show) {
      setFilters({
        is_client_details_received: "",
        payment_status: "",
        payment_confirmed: "",
        is_approved_by_partner: "",
        print_status: "",
        is_sleeve_handover_to_warehouse: "",
        is_sleeve_received_to_warehouse: "",
        start_date: "",
        end_date: "",
        ...initialFilters,
      });
    }
  }, [show, initialFilters]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Filter Orders</Modal.Title>
      </Modal.Header>
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            <Row className="gx-3 gy-2">
              <Col xs={12} sm={6} md={4} lg={3}>
                {/* {Client Details received} */}
                <Form.Label>Client Details Received</Form.Label>
                <Form.Select
                  value={filters.is_client_details_received}
                  onChange={(e) =>
                    updateFilter("is_client_details_received", e.target.value)
                  }
                >
                  <option value="">All</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Form.Select>
              </Col>
              {/* Payment Status */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Payment Status</Form.Label>
                <Form.Select
                  value={filters.payment_status}
                  onChange={(e) =>
                    updateFilter("payment_status", e.target.value)
                  }
                >
                  <option value="">All</option>
                  <option value="Received">Received</option>
                  <option value="Pending">Pending</option>
                </Form.Select>
              </Col>

              {/* Payment Confirmed */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Payment Confirmed</Form.Label>
                <Form.Select
                  value={filters.payment_confirmed}
                  onChange={(e) =>
                    updateFilter("payment_confirmed", e.target.value)
                  }
                >
                  <option value="">All</option>
                  <option value="true">Confirmed</option>
                  <option value="false">Pending</option>
                </Form.Select>
              </Col>

              {/* Approval by Partner */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Approval by Partner</Form.Label>
                <Form.Select
                  value={filters.is_approved_by_partner}
                  onChange={(e) =>
                    updateFilter("is_approved_by_partner", e.target.value)
                  }
                >
                  <option value="">All</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Form.Select>
              </Col>

              {/* Print Status */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Print Status</Form.Label>
                <Form.Select
                  value={filters.print_status}
                  onChange={(e) => updateFilter("print_status", e.target.value)}
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Done">Done</option>
                </Form.Select>
              </Col>

              {/* Sleeve Handover */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Sleeve Handover</Form.Label>
                <Form.Select
                  value={filters.is_sleeve_handover_to_warehouse}
                  onChange={(e) =>
                    updateFilter(
                      "is_sleeve_handover_to_warehouse",
                      e.target.value
                    )
                  }
                >
                  <option value="">All</option>
                  <option value="true">Sent</option>
                  <option value="false">Pending</option>
                </Form.Select>
              </Col>

              {/* Sleeve Received */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Sleeve Received</Form.Label>
                <Form.Select
                  value={filters.is_sleeve_received_to_warehouse}
                  onChange={(e) =>
                    updateFilter(
                      "is_sleeve_received_to_warehouse",
                      e.target.value
                    )
                  }
                >
                  <option value="">All</option>
                  <option value="true">Received</option>
                  <option value="false">Pending</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.start_date}
                  onChange={(e) => updateFilter("start_date", e.target.value)}
                  max={filters.end_date || undefined}
                  isInvalid={!!dateError.start}
                />
                {dateError.start && (
                  <div className="text-danger small mt-1">
                    {dateError.start}
                  </div>
                )}
              </Col>

              {/* End Date */}
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.end_date}
                  onChange={(e) => updateFilter("end_date", e.target.value)}
                  min={filters.start_date || undefined}
                  isInvalid={!!dateError.end}
                />
                {dateError.end && (
                  <div className="text-danger small mt-1">{dateError.end}</div>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={clearFilters}>
          Clear All
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            onApply(filters);
            onHide();
          }}
          disabled={!!dateError.start || !!dateError.end}
        >
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
